import {Capability, type FieldDefinition, type FieldsData} from './fields'

/**
 * The fields the view definition declares as supporting `capability`, in declaration order.
 * Grouping and sorting must support every item type; an attribute may apply to just one.
 */
export function getFieldsForCapability(view: FieldsData, capability: Capability): FieldDefinition[] {
  if (view.itemTypes.length === 0) return []
  return view.fields.filter(field => {
    const supports = (itemType: FieldsData['itemTypes'][number]) =>
      field.capabilities[capability]?.includes(itemType) ?? false
    return capability === Capability.ATTRIBUTABLE ? view.itemTypes.some(supports) : view.itemTypes.every(supports)
  })
}
